import { Card, Text, Group, Button } from '@mantine/core';
import { Check, X } from 'react-feather';
import type { InterestStatus } from '../../../services/api/coachPortal';

export interface InterestQuestionCardProps {
  value: InterestStatus | null;
  onChange: (status: InterestStatus) => void;
  perspective?: 'coach' | 'cm';
}

export function InterestQuestionCard({ value, onChange, perspective = 'coach' }: InterestQuestionCardProps) {
  const isCm = perspective === 'cm';

  return (
    <Card withBorder padding="lg" radius="md">
      <Text fw={600} mb="xs">
        {isCm
          ? 'Is the coach interested in this coaching opportunity?'
          : 'Are you interested in this coaching opportunity?'}
      </Text>
      <Text size="sm" c="dimmed" mb="md">
        {isCm
          ? 'Indicate whether the coach is available for this cohort.'
          : "Let us know if you'd like to be considered for this cohort."}
      </Text>
      <Group grow>
        <Button
          size="lg"
          variant={value === 'interested' ? 'filled' : 'outline'}
          color={value === 'interested' ? 'green' : 'gray'}
          leftSection={<Check size={18} />}
          onClick={() => onChange('interested')}
          styles={{
            root: {
              borderWidth: 2,
            },
          }}
        >
          {isCm ? 'Yes, Coach is Interested' : "Yes, I'm interested"}
        </Button>
        <Button
          size="lg"
          variant={value === 'not_interested' ? 'outline' : 'outline'}
          color={value === 'not_interested' ? 'red' : 'gray'}
          leftSection={<X size={18} />}
          onClick={() => onChange('not_interested')}
          styles={{
            root: {
              borderWidth: 2,
              borderColor:
                value === 'not_interested'
                  ? 'var(--mantine-color-red-5)'
                  : undefined,
              color:
                value === 'not_interested'
                  ? 'var(--mantine-color-red-6)'
                  : undefined,
            },
          }}
        >
          {isCm ? 'No, Coach Not Interested' : "No, I'll pass on this one"}
        </Button>
      </Group>
    </Card>
  );
}
